import ChatMembership from 'entities/ChatMembership';
import Collection from 'lib/Collection';

class ChatMemberships extends Collection<ChatMembership> {
  initialize() {
    // @ts-ignore - ts thinks we are using a type here.  This is generally kinda wonk but dont wanna risk code change
    this.model = ChatMembership;
  }
}

export default ChatMemberships;
